
import React from "react";
import { FormFieldType } from "@/types/form";
import { FieldWrapper } from "./FieldWrapper";
import { InstructionBox } from "../components";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface RichTextInstructionProps {
  element: FormFieldType;
}

export const RichTextInstructionField: React.FC<RichTextInstructionProps> = ({ element }) => {
  const { t } = useTranslation();
  if (!element.text) return null;
  const html = tField(t, element.text);

  return (
    <FieldWrapper element={element}>
      <InstructionBox>
        <div
          className="text-sm richtext-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </InstructionBox>
    </FieldWrapper>
  );
};

export default RichTextInstructionField;
